import { Stack } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";
import { LegendItem } from "@/Components/v2/molecule/LegendItem/LegendItem";

type LegendItem = {
  name: string;
  color: string;
  isActive: boolean;
};

type LegendProps = {
  legends: LegendItem[];
  handleClick: (channelName: string) => void;
};

const Legend = ({ legends, handleClick }: LegendProps) => (
  <Stack pl={5} gap={1}>
    <Typography variant="body2" fontWeight={600}>
      Channels
    </Typography>
    <Box pl={0.5}>
      <Stack direction="row" gap={1.5} flexWrap="wrap">
        {legends.map((legend) => (
          <LegendItem
            key={legend.name}
            item={{
              ...legend,
              title: legend.name,
              id: legend.name,
            }}
            handleClick={() => handleClick(legend.name)}
          />
        ))}
      </Stack>
    </Box>
  </Stack>
);

export default Legend;
